import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import _ from 'underscore';

import { inPlayOverviewChangeFilter } from 'InPlayOverview/duck';
import MarketfilterContext from 'InPlayOverview/services/marketfilter_context';

export const PeriodSelectorComponent = ({ changeMarketType, sport }) => (
  <MarketfilterContext.Consumer>
    {({ marketType, period }) => ([
      <p className="inply-coupon-header__market-name">{marketType.mtDesc}</p>,
      <p className="inply-coupon-header__periods">
        {
            marketType.periods.map((p) => (
              <span
                className={`period bvs-link ${_.isEqual(p, period) ? 'active' : ''}`}
                onClick={() => (changeMarketType(sport.id, marketType, p))}
              >
                {p.desc}
              </span>
            ))
          }
      </p>,
    ])}
  </MarketfilterContext.Consumer>
);

PeriodSelectorComponent.propTypes = {
  sport: PropTypes.isRequired,
  changeMarketType: PropTypes.isRequired,
};

const mapDispatchToProps = (dispatch) => ({
  changeMarketType: (sportId, marketType, period) => {
    inPlayOverviewChangeFilter(sportId, marketType, period)(dispatch);
  },
});

export default connect(null, mapDispatchToProps)(PeriodSelectorComponent);
